import { render, staticRenderFns } from "./SalesProductsGroupedbyDayOfWeek.vue?vue&type=template&id=5f1e4671&scoped=true&"
import script from "./SalesProductsGroupedbyDayOfWeek.vue?vue&type=script&lang=js&"
export * from "./SalesProductsGroupedbyDayOfWeek.vue?vue&type=script&lang=js&"
import style0 from "./SalesProductsGroupedbyDayOfWeek.vue?vue&type=style&index=0&id=5f1e4671&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1e4671",
  null
  
)

export default component.exports